import { render, staticRenderFns } from "./SpecificProductRulesForm.vue?vue&type=template&id=485de4c2&scoped=true"
import script from "./SpecificProductRulesForm.vue?vue&type=script&lang=js"
export * from "./SpecificProductRulesForm.vue?vue&type=script&lang=js"
import style0 from "./SpecificProductRulesForm.vue?vue&type=style&index=0&id=485de4c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485de4c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485de4c2')) {
      api.createRecord('485de4c2', component.options)
    } else {
      api.reload('485de4c2', component.options)
    }
    module.hot.accept("./SpecificProductRulesForm.vue?vue&type=template&id=485de4c2&scoped=true", function () {
      api.rerender('485de4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/monitoringScreen/specificProduct/SpecificProductRulesForm.vue"
export default component.exports